import { render, staticRenderFns } from "./Inspector.vue?vue&type=template&id=146d4e43&scoped=true"
import script from "./Inspector.vue?vue&type=script&lang=ts"
export * from "./Inspector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146d4e43",
  null
  
)

export default component.exports